/* src/app/components/review/ai-multi-doc-prompt/ai-multi-doc-prompt.component.scss */
.mat-mdc-dialog-content {
  padding: 12px 24px 12px 24px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: #303f9f;
  color: white;
}
.form-control-wrapper {
  padding-bottom: 10px;
  width: 100%;
}
.form-control-wrapper mat-form-field {
  width: 100%;
}
mat-form-field {
  --floating-label-font-size: 12px;
}
.center-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  font-size: 10px;
}
.warning-hint {
  color: rgb(63, 81, 181) !important;
  display: flex;
  font-size: 10px;
}
.error-hint {
  color: red !important;
  display: flex;
  font-size: 10px;
}
.hint-icon {
  margin-right: 3px !important;
  font-size: 11px !important;
}
.prompt-item {
  padding: 10px 36px 10px 16px;
  height: auto;
  cursor: default;
}
.prompt-item-title {
  font-size: 13px;
  line-height: 20px;
}
.prompt-item-complete-prompt {
  font-size: 10px;
  text-overflow: ellipsis;
  line-height: 16px;
  max-height: 32px;
  overflow: hidden;
  white-space: nowrap;
}
@supports (-webkit-line-clamp: 2) {
  .prompt-item-complete-prompt {
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(50, end) 750ms infinite;
  animation: ellipsis steps(50, end) 750ms infinite;
  content: "....";
  width: 0px;
}
@keyframes ellipsis {
  to {
    width: 1.25em;
  }
}
@-webkit-keyframes ellipsis {
  to {
    width: 1.25em;
  }
}
.delete-button {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-icon {
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  padding-left: 16px;
  padding-top: 10px;
}
.hover-over-button {
  float: right;
  padding-right: 5px;
  border: unset;
  cursor: pointer;
  background: inherit;
}
.hover-over-icon {
  padding-left: 4px;
  padding-top: 4px;
  font-size: 16px;
  cursor: pointer;
  color: black;
}
:host-context(.dark-theme) .mat-mdc-button-disabled {
  background: transparent !important;
}
:host-context(.dark-theme) .ai-engine-select.mat-form-field-disabled {
  --opacity: 0.4;
}
:host-context(.dark-theme) .hover-over-icon {
  color: white;
}
:host-context(.dark-theme) .prompt-control-icon {
  color: white;
}
:host-context(.dark-theme) .prompt-control-icon[disabled] {
  color: rgba(255, 255, 255, 0.3019607843);
}
.prompt-control-icon {
  color: black;
}
.prompt-control-icon[disabled] {
  color: rgba(0, 0, 0, 0.26);
}
.clear-icon {
  font-size: 16px;
  align-content: center;
}
.wrapper {
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.wrapper-button {
  padding-left: 50px;
  padding-right: 60px;
}
/*# sourceMappingURL=ai-multi-doc-prompt.component.css.map */
